import React from 'react';

import styles from './styles.module.scss';

export const ProgressBar: React.FC = () => (
  <div className={styles.progressBarContainer}>
    <div className={styles.progressBar} />
  </div>
);
